import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React from 'react';
import styled, { keyframes } from 'styled-components';
import { cleanWhite, flamingo } from '../colors';
/*::
import type { Node } from 'react';

export type IconProps = {|
  width?: number,
  height?: number,
  color?: string,
  sliceColor?: string,
  sliceOpacity?: number,
|}
*/

var WDZ = 22;
var HGT = 22;
var WTH = WDZ / HGT;
var HTW = HGT / WDZ;

var SpinnerIcon = function SpinnerIcon(_ref
/*: $Rest<IconProps, any> */
) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? flamingo() : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? WDZ / 10 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? HGT / 10 : _ref$height,
      _ref$sliceColor = _ref.sliceColor,
      sliceColor = _ref$sliceColor === void 0 ? cleanWhite() : _ref$sliceColor,
      _ref$sliceOpacity = _ref.sliceOpacity,
      sliceOpacity = _ref$sliceOpacity === void 0 ? 0.7 : _ref$sliceOpacity,
      rest = _objectWithoutPropertiesLoose(_ref, ["color", "width", "height", "sliceColor", "sliceOpacity"]);

  var w = width * 10 === WDZ ? height * WTH : width;
  var h = height * 10 === HGT ? width * HTW : height;
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 " + WDZ + " " + HGT,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: w + "rem",
      height: h + "rem"
    }
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "m 11,20 c 4.9706,0 9,-4.0294 9,-9 0,-4.97056 -4.0294,-9 -9,-9 -4.97056,0 -9,4.02944 -9,9 0,4.9706 4.02944,9 9,9 z" // eslint-disable-line max-len
    ,
    stroke: color,
    strokeWidth: "4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: sliceOpacity,
    d: "M 19.574219 4.1132812 L 16.201172 6.3359375 A 6.9949999 6.9949999 0 0 1 17.994141 11 A 6.9949999 6.9949999 0 0 1 16.25 15.611328 L 16.28125 15.857422 L 19.544922 17.914062 A 11.000163 11.000163 0 0 0 22 11 A 11.000163 11.000163 0 0 0 20.802734 6.0097656 A 11.000163 11.000163 0 0 0 19.574219 4.1132812 z" // eslint-disable-line max-len
    ,
    fill: sliceColor
  }));
};

var rotate = keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
var Spinner = styled(SpinnerIcon).withConfig({
  displayName: "spinner__Spinner",
  componentId: "sc-256xi2-0"
})(["animation:", " 1.2s linear infinite;"], rotate);
export default Spinner;